import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
} from "@mui/material";
import dayjs from "../../shared utils/dayjsConfig.js";

const fmt = (d) => (d ? dayjs(d).format("ddd D MMM") : "");

function roomLabel(room) {
  if (!room) return "Unassigned";
  const house = room.house ? `${room.house} ` : "";
  return `${house}${room.groupName || room.bedroomName || "room"}`;
}

// Offered after a mid-stay placement: allocate the room for the resident's whole
// stay (if it's free) instead of only from the viewed date. `prompt` is null
// when closed.
export default function WholeStayPromptDialog({
  prompt,
  onWholeStay,
  onKeepFromDate,
  onCancel,
}) {
  if (!prompt) return null;

  const { resident, targetRoom, fromRoom, selectedDate, availability } = prompt;
  const name = `${resident?.name || ""} ${resident?.surname || ""}`.trim();
  const firstName = resident?.name || "them";
  const room = roomLabel(targetRoom);
  const fromDate = fmt(selectedDate);
  const isMove = Boolean(fromRoom);
  const available = Boolean(availability?.available);

  return (
    <Dialog open onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>{isMove ? "Mid-stay move" : "Mid-stay placement"}</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">
          {name} into <strong>{room}</strong> from <strong>{fromDate}</strong>.
          <br />
          Earlier nights ({fmt(resident?.stay_start)} to{" "}
          {fmt(dayjs(selectedDate).subtract(1, "day"))}){" "}
          {isMove ? (
            <>stay in <strong>{roomLabel(fromRoom)}</strong>.</>
          ) : (
            <>have no room.</>
          )}
        </DialogContentText>

        <Alert severity={available ? "success" : "warning"} sx={{ mt: 2 }}>
          {available ? (
            <>
              {room} is free for {firstName}&apos;s whole stay (
              {fmt(resident?.stay_start)} to {fmt(resident?.stay_end)}).
            </>
          ) : (
            <>
              {room} isn&apos;t free for the whole stay — already taken{" "}
              {availability?.blockedSummary}. You can still place them from{" "}
              {fromDate}.
            </>
          )}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          Cancel
        </Button>
        <Button onClick={onKeepFromDate}>Just from {fromDate}</Button>
        {available && (
          <Button onClick={onWholeStay} variant="contained">
            Give {firstName} {room} for the whole stay
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
